import { render, staticRenderFns } from "./wsWebinarItemsList.vue?vue&type=template&id=a6fb0ebc&scoped=true&"
import script from "./wsWebinarItemsList.vue?vue&type=script&lang=js&"
export * from "./wsWebinarItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fb0ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
